import { createAction } from "@reduxjs/toolkit";

const actionTypes = {
	getWithdraws : createAction("getWithdraws"),
	getWithdrawals: createAction("getWithdrawals")
}

export default actionTypes;
